/**
 * @generated SignedSource<<d296dd950b5a054b0f0918f3ae40e0fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type headerOnelineMenuQuery$variables = Record<PropertyKey, never>;
export type headerOnelineMenuQuery$data = {
  readonly pwaOnelineMenu: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
};
export type headerOnelineMenuQuery = {
  response: headerOnelineMenuQuery$data;
  variables: headerOnelineMenuQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "pwaOnelineMenu",
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "entityId": "scmp_pwa_oneline_menu"
        }
      }
    ],
    "concreteType": "AppConfigs",
    "kind": "LinkedField",
    "name": "appConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
      }
    ],
    "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_oneline_menu\"})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "headerOnelineMenuQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "headerOnelineMenuQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "6861d5fa186a1208717a591771e2de07",
    "id": null,
    "metadata": {},
    "name": "headerOnelineMenuQuery",
    "operationKind": "query",
    "text": "query headerOnelineMenuQuery {\n  pwaOnelineMenu: appConfig(filter: {entityId: \"scmp_pwa_oneline_menu\"}) {\n    json\n  }\n}\n"
  }
};
})();

(node as any).hash = "ab619446baa54060e980189f31d4b16a";

export default node;
